/* eslint-disable no-console */

export const check = (nav = navigator, win = window) => {
  if (!('serviceWorker' in nav)) {
    console.error('No Service Worker support!')
    return false
  }
  if (!('PushManager' in win)) {
    console.warn('No Push API Support!')
  }
  return true
}

export const registerServiceWorker = async (nav = navigator, baseUrl = '/') => {
  try {
    return await nav.serviceWorker.register(`${baseUrl}sw.js`)
  } catch (e) {
    console.error(e)
  }
  return null
}

const main = async () => {
  // Retorno silencioso quando serviceWorker não está disponível.
  // Evita console.error no ambiente de testes (jsdom não tem serviceWorker).
  if (!('serviceWorker' in navigator)) return
  check()
  await registerServiceWorker(navigator, process.env.BASE_URL || '/')
}

main().catch((e) =>
  console.error(
    '[notification] Erro inesperado ao inicializar notificações. Tente recarregar a página ou contate o suporte.',
    e
  )
)
